import TTHardBreak from "@tiptap/extension-hard-break"
import type { Node as ProsemirrorNode, Schema } from "prosemirror-model"

const component = TTHardBreak.extend({
  name: "hard_break"
})

const HARD_BREAK_STR = "\n"

const converter = {
  fromPrismic(schema: Schema) {
    return function (text: string): ProsemirrorNode | undefined {
      if (text !== HARD_BREAK_STR) return
      return schema.nodes[component.name]?.create({})
    }
  },

  toPrismic(node: ProsemirrorNode): string | undefined {
    if (node.type.name !== component.name) return
    return HARD_BREAK_STR
  }
}

const Rules = {
  isEmptyLine(textPart: string): boolean {
    return textPart.length === 0
  },
  isFirst(index: number): boolean {
    return index === 0
  }
}

function splitTextToNodes(schema: Schema, text: string) {
  return function (
    textToNode: (strText: string) => ProsemirrorNode
  ): ProsemirrorNode[] {
    const hardBreakNode = converter.fromPrismic(schema)(HARD_BREAK_STR)
    // HardBreak doesn't exist in the schema for some reason
    if (!hardBreakNode) return [textToNode(text)]

    const splitted = text.split(HARD_BREAK_STR)
    if (splitted.length === 1)
      return text.length ? [textToNode(text)] : [hardBreakNode]

    return splitted.reduce<ProsemirrorNode[]>((acc, textPart, index) => {
      if (Rules.isFirst(index)) {
        if (Rules.isEmptyLine(textPart)) return acc
        return [...acc, textToNode(textPart)]
      }

      if (Rules.isEmptyLine(textPart)) return [...acc, hardBreakNode]
      return [...acc, hardBreakNode, textToNode(textPart)]
    }, [])
  }
}

const EditorHardBreak = {
  name: component.name,
  component,
  converter,
  splitTextToNodes
}

// eslint-disable-next-line import/no-default-export
export default EditorHardBreak
